// extracted by mini-css-extract-plugin
export default {"filter":"Filter_filter__SpzjF","form":"Filter_form__QkOU1","label":"Filter_label__5OzDC","services":"Filter_services__4+P3X","posts":"Filter_posts__RyeGm"};